/* eslint-disable import/no-anonymous-default-export */
import { SessionState, UPDATE_SESSION, SessionActionTypes } from './types'

const updateSession = (newSession: Partial<SessionState>): SessionActionTypes => {
    return {
        type: UPDATE_SESSION,
        payload: newSession
    }
}

export default {
    updateSession,
    //...
}